import { BACKEND_CONSTANTS } from './constants'

import { patch } from './helpers'

const updateSupplierCode = async (id, supplierCode) =>
  patch(`product_suppliers/${id}`, BACKEND_CONSTANTS.PRODUCT_SUPPLIER.UPDATE_SUPPLIER_CODE, { supplierCode })

export { updateSupplierCode }
